<template>
  <div class="container">
    <h1>Craniosacrale Energiebalance am Hund</h1>

    <p>Bei einem Ersttermin eines Hundes beginne ich stets mit dem Kennenlernen des Hundes und 
      dem Gespräch mit dem Besitzer. Durch sanfte Berührungen kann ich Spannungsfelder im Körper 
      des Hundes erkennen und mittels minimaler Mobilisationstechniken einen harmonischen Energiefluss 
      wiederherstellen. Hunde brauchen in der Regel etwas Zeit um sich auf die Anwendung einzulassen. 
      Der Hund darf das Tempo bestimmen.</p>


      <Slider :data="content" />   

    <p><b>Hunde profitieren besonders bei den folgenden Problemstellungen von einer Craniosacralen Energiebalance:</b></p>

    <ul class="list">
      <li>Gangproblemen</li>
      <li>Rücken- und insbesondere Bandscheibenproblemen</li>
      <li>Beckenschiefstellungen</li>
      <li>nach Operationen (Kastrationen), zur Narbenentstörung</li>
      <li>Begleitung älterer Hunde, Steigerung der Lebensqualität</li>
    </ul>

    <p>Hunde brauchen erfahrungsgemäß mehrere Pausen während einer Anwendung. Planen Sie deswegen bitte 
      insgesamt 1-2h Zeit ein.</p>

    <p>Schiefes Gehen oder Sitzen ist nicht normal, ebenso wenig ein zweispuriges Laufen. Wenn Sie erste 
      Anzeichen an Ihrem Hund wahrnehmen, zögern Sie nicht mich anzurufen.</p>

    <router-link :to="{ path: 'energiebalance#uebersicht' }" class="block margin-tb align-right">zurück zur Übersicht</router-link> 

  </div>
</template>

<script>
import Slider from "./shared/Slider.vue";

export default {
  name: "CranioHund", //this is the name of the component
   metaInfo() {
        return { 
            title: "Craniosacrale Energiebalance für Hunde - Katharina Herda",
            meta: [
                { name: 'description', content:  'Craniosacrale Energiebalance unterstützt den Körper sich selbst von Schmerzen und Blockaden zu befreien, indem der natürliche Fluss wiederhergestellt wird.'},
                { property: 'og:title', content: "Craniosacrale Energiebalance für Hunde - Katharina Herda"},
                { property: 'og:description', content: 'Craniosacrale Energiebalance unterstützt den Körper sich selbst von Schmerzen und Blockaden zu befreien, indem der natürliche Fluss wiederhergestellt wird.'},    
                { property: 'og:image', content: 'src/img/assets/slider-hund/cranio-hund2.jpg'},
                { property: 'og:url', content: 'www.herda.at/energiebalance-hund'}

            ]
        }
    },
    components: {
    "Slider": Slider,
  },
  
  data() { 
    return {
      content: {
        heading: 'Impressionen von der Craniosacralen Energiebalance mit Hunden', 
        slides: [{ className: 'slider-hund-1', htmlContent: `<span class="sr-only">Katharina Herda führt eine Anwendung an einem Hund im Garten durch</span>`
          },
          { className: 'slider-hund-2', htmlContent: `<span class="sr-only">Katharina Herda führte sanfte Regulationen am Becken des Hundes durch</span>`
          },
          { className: 'slider-hund-3', htmlContent: `<span class="sr-only">Katharina Herda reguliert sanfte das Brustbein des Hundes</span>`
          }, 
          { className: 'slider-hund-4', htmlContent: `<span class="sr-only">Katharina Herda behandelt die Leistenregion der Hündin</span>`
          },
          { className: 'slider-hund-5', htmlContent: `<span class="sr-only">Katharina Herda führt sanfte Bewegungen am Brustkorb des Hundes aus</span>`
          }
          
        ]

      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CranioHund.vue